import { styled } from '@mui/material/styles';

export const StyledSVG = styled('svg')({
  display: 'block',
});
